/**
 * filters and returns array of nodes
 *
 * @param {Node} nodes
 * @param {Array} type
 */
export default function FilterNodes(nodes, type) {
	return [...nodes].filter(e => e.nodeName == type);
}
